import { LocalAuthState } from '../types';
import { getAuthState as getKeycloakAuthState } from '../keycloak/state';

function getAuthState(): LocalAuthState | null {
  return getKeycloakAuthState();
}

export { getAuthState };
